export enum TransportStep {
  SEARCH_OFFERS = 'SEARCH_OFFERS',
  PICKUP = 'PICKUP',
  ITEMS = 'ITEMS',
  DELIVERY = 'DELIVERY',
  EXTRA_CONDITION = 'EXTRA_CONDITION',
  LOGIN = 'LOGIN',
  QUOTATION = 'QUOTATION',
  BASKET = 'BASKET',
}
